import Utils from '@/ecm/common/Utils';
export default class DistributionItem {
    constructor(dto) {
        this.distributionDetailsId = 0;
        this.uuid = Utils.object.getUUID();
        this.autor = '';
        this.isViewed = false;
        this.requiresValidation = false;
        this.requiresSignature = false;
        this.isValidated = false;
        this.isRejected = false;
        this.isExpired = false;
        this.isSigned = false;
        this.dueDate = '';
        this.distributionId = 0;

        if (dto) {
            this.distributionDetailsId = dto.DistributionDetailsId;
            this.distributionId = dto.DistributionId;
            this.autor = dto.UserName;
            this.isViewed = dto.IsViewed;
            this.requiresValidation = dto.RequiresValidation;
            this.requiresSignature = dto.RequiresSignature;
            this.isValidated = dto.IsValidated;
            this.isRejected = dto.IsRejected;
            this.isSigned = dto.IsSigned;
            this.dueDate = dto.DisplayDueDate;
        }
    }
}
